module.exports = __webpack_public_path__ + "img/MamasBrille.86af902e.svg";